import React from 'react'
import classes from '@src/styles/WhyWorkWithUs.module.css'
import paymentIcon from '@src/assets/why-work/payment.svg'
import convenienceIcon from '@src/assets/why-work/convenience.svg'
import digitalIcon from '@src/assets/why-work/digital.svg'
import rewardIcon from '@src/assets/why-work/reward.svg'
import nationwideIcon from '@src/assets/why-work/nationwide.svg'
import { useRouter } from 'next/router'
import { segmentTrack } from '@src/functions/segment'
import queryString from 'query-string'
import { withAttribution } from '@src/functions/attribution'

function WhyWorkWithUs() {
  const history = useRouter()

  const handleButtonClick = (userType: string) => {
    // eslint-disable-next-line no-console
    console.log('handleButtonClick : userType', userType)
    // dispatch({ type: 'SET_TEMP_USER', userType })
    history.push(
      withAttribution(
        `${process.env.NEXT_PUBLIC_REDIRECT_URL}?`.concat(
          queryString.stringify({
            login: '1',
          }),
        ),
      ),
    )
    segmentTrack('User Clicks Register - Provider Portal', { userType });
  }

  return (
    <section className={classes.container}>
      <div className={classes.mainContent}>
        <h2 className={classes.heading}>Why Work with Dimension</h2>
        <div className={classes.gridContainer}>
          <div className={classes.box}>
            <img alt='' src={paymentIcon.src} />
            <h4 className={classes.boxHeader}>Reliable and Fast Payments</h4>
            <p className={classes.boxDescription}>
              Never chase another invoice! Dimension ensures you’ll be paid via Stripe within days
              of completing the job.
            </p>
          </div>
          <div className={classes.box}>
            <img alt='' src={convenienceIcon.src} />
            <h4 className={classes.boxHeader}>Convenience and Independence</h4>
            <p className={classes.boxDescription}>
              Pick up as many or as few jobs as you want, whenever it suits you, thanks to our
              flexible system.
            </p>
          </div>
          <div className={classes.box}>
            <img alt='' src={digitalIcon.src} />
            <h4 className={classes.boxHeader}>Fully Digital</h4>
            <p className={classes.boxDescription}>
              Dimension offers an easy and secure way to find and secure jobs online - saving you
              time to focus on your work.
            </p>
          </div>
          <div className={classes.box}>
            <img alt='' src={rewardIcon.src} />
            <h4 className={classes.boxHeader}>Be Rewarded for Your Performance</h4>
            <p className={classes.boxDescription}>
              Our most trusted providers are rewarded for their consistent performance with first
              access to our highest paid jobs.
            </p>
          </div>
          <div className={classes.box}>
            <img alt='' src={nationwideIcon.src} />
            <h4 className={classes.boxHeader}>Nationwide Presence</h4>
            <p className={classes.boxDescription}>
              We work with all types of customers across the country, allowing you to pick the jobs
              that are best suited to your vehicles and team size.
            </p>
          </div>
        </div>
        <button className={classes.primaryButton} onClick={() => handleButtonClick('provider')}>
          Sign Up Now
        </button>
      </div>
    </section>
  )
}

export default WhyWorkWithUs
